import React, { useEffect, useState } from 'react';
import { GetConfirmationRequirements, GetRegistrationInitData, PassportCheck } from '../../slice';
import { FlexColumnCentered } from '../../../../components/ui/Content';
import { IRegisterForm } from '../../../../interface/Auth/frontend';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import moment from 'moment';
import { PhoneMail } from '../PhoneMail';
import { GetIdentityCardType } from '../../../Passport/AccountInfo/api/slice';
import 'react-phone-number-input/style.css';
import { useSearchParams } from 'react-router-dom';
import { LocalStorageEnum } from '../../../../enum/localStorage';
import FormTitle from './Components/FormTitle';
import { PassportContainer } from './Inputs/Passport/PassportContainer';
import RegFormWrapper from './Components/RegFormWrapper';
import { FooterLink } from './Components/FooterLink';
import { BoxIsolated, RegisterFooter } from './styles';
import { RegFormLastName } from './Inputs/RegFormLastName';
import { RegFormName } from './Inputs/RegFormName';
import { RegFormMiddleName } from './Inputs/RegFormMiddleName';
import { RegFormDate } from './Inputs/RegFormDate';
import { PersonalDataAgreement } from './Inputs/PersonalDataAgreement';
import { RegFromLoader } from './Components/RegFromLoader';
import { RegFormSendButton } from './Components/RegFormSendButton';
import {
	AgreementType,
	checkAgreement,
	checkBirthDate,
	checkForeignPassport,
	checkLastName,
	checkMail,
	checkMailSubmit,
	checkName,
	checkPhone,
	checkPhoneSubmit,
	checkRuPassport,
} from './functions/checkRegFormFunctions';

interface IRegisterFormProps {
	registerForm: IRegisterForm;
	onResetForm(): void;
	setRegisterForm(value: IRegisterForm): void;
	onSetPassword(): void;
}

export const RegisterForm = ({ registerForm, setRegisterForm, onSetPassword }: IRegisterFormProps) => {
	const { mail, phone, phoneSubmit, mailSubmit } = useAppSelector(state => state.auth);
	const { isFetching } = useAppSelector(state => state.account);
	const dispatch = useAppDispatch();
	const [searchParams] = useSearchParams();
	const searchParamsToken = searchParams.get('token');
	const [agreementGiven, setAgreementGiven] = useState(false);
	const [agreementModalType, setAgreementModalType] = useState<AgreementType | null>(null);

	useEffect(() => {
		if (searchParamsToken) {
			localStorage.setItem(LocalStorageEnum.registerToken, searchParamsToken);
			dispatch(GetRegistrationInitData(searchParamsToken));
			return;
		}
	}, []);

	useEffect(() => {
		dispatch(GetIdentityCardType());
		dispatch(GetConfirmationRequirements());
	}, []);

	const checkFormFields = () => {
		const fields = [
			checkPhone(phone),
			checkMail(mail),
			checkPhoneSubmit(phoneSubmit),
			checkMailSubmit(mailSubmit),
			checkName(registerForm),
			checkLastName(registerForm),
			checkBirthDate(registerForm),
			checkRuPassport(registerForm),
			checkForeignPassport(registerForm),
			checkAgreement(agreementGiven),
		];

		return fields.includes(true);
	};

	const isButtonDisabled = () => {
		return checkFormFields();
	};

	const onSend = () => {
		if (mail && phone && registerForm.birthDate && registerForm.citizenshipId) {
			dispatch(
				PassportCheck({
					email: mail,
					phone: phone,
					citizenshipId: registerForm.citizenshipId,
					name: registerForm.name,
					surname: registerForm.surname,
					patronymic: registerForm.patronymic || null,
					birthDate: moment(registerForm.birthDate).format('YYYY-MM-DD'),
					passportSeries: registerForm.passportSeries,
					passportNumber: registerForm.passportNumber,
				})
			).then(res => {
				if (res.type.includes('fulfilled')) {
					onSetPassword();
				}
			});
		}
	};

	const isInputDisabled = () => {
		return isFetching || checkRuPassport(registerForm) || checkForeignPassport(registerForm);
	};

	return (
		<RegFormWrapper>
			<FlexColumnCentered className={'new-register-params'}>
				<FormTitle />
				<BoxIsolated className='reg-content'>
					<PassportContainer registerForm={registerForm} setRegisterForm={setRegisterForm} />

					<PhoneMail isDisabled={isInputDisabled()} registerForm={registerForm} />

					<RegFormLastName
						registerForm={registerForm}
						setRegisterForm={setRegisterForm}
						isDisabled={isInputDisabled()}
					/>

					<RegFormName registerForm={registerForm} setRegisterForm={setRegisterForm} isDisabled={isInputDisabled()} />

					<RegFormMiddleName
						registerForm={registerForm}
						setRegisterForm={setRegisterForm}
						isDisabled={isInputDisabled()}
					/>

					<RegFormDate registerForm={registerForm} setRegisterForm={setRegisterForm} />

					<PersonalDataAgreement
						agreementGiven={agreementGiven}
						setAgreementGiven={setAgreementGiven}
						agreementModalType={agreementModalType}
						setAgreementModalType={setAgreementModalType}
					/>
				</BoxIsolated>
				<RegisterFooter className='reg-footer'>
					<RegFormSendButton isDisable={isButtonDisabled()} onSend={onSend} />
				</RegisterFooter>
				<RegFromLoader />
			</FlexColumnCentered>
			<FooterLink />
		</RegFormWrapper>
	);
};
